{
  "type": "object",
  "name": "",
  "class": "g gtc-2 gr-5 gap",
  "definitions": [
    {
      "name": "from",
      "type": "date",
      "title": "Von",
      "control": "time",
      "class": "gr-2 gc-1",
      "required": true
    },
    {
      "name": "to",
      "type": "date",
      "title": "Bis",
      "control": "time",
      "class": "gr-2 gc-2",
      "required": true
    },
    {
      "name": "object",
      "type": "fieldOk",
      "title": "Objekt",
      "autoLoad": true,
      "virtual": { "itemHeight": 54, "display": { "default": 9, "small": 4 } },
      "fieldOk": "objekt",
      "format": "{{number}} - {{name}}",
      "resultMapping": {
        "objekt": "number",
        "bezeichnung": "name"
      },
      "parameters": {
        "status": "O",
        "idktostamm_kunde": { "type": "valueReference", "path": "customer.id" }
      },
      "views": [
        {
          "type": "list",
          "title": "Daten",
          "definition": {
            "type": "object",
            "name": "",
            "class": "truncate px-2",
            "definitions": [
              {
                "type": "string",
                "class": "soft-overline",
                "name": "object"
              },
              {
                "type": "string",
                "class": "truncate",
                "name": "number"
              }
            ]
          }
        }
      ],
      "class": "gr-1 gc-1-2",
      "required": true
    },
    {
      "name": "description",
      "type": "string",
      "title": "Beschreibung",
      "control": "multiline",
      "class": "gr-3 gc-1-2"
    }
  ]
}
